
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/[[...tabs]]",
      function () {
        return require("private-next-pages/search/[[...tabs]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/[[...tabs]]"])
      });
    }
  